import axios from "axios";
import { invalidateAuthSession } from "./authSessionInvalidation";

const founderApi = axios.create({
  baseURL: "/api/v1",
  headers: {
    Accept: "application/json",
  },
  withCredentials: true,
});

founderApi.interceptors.response.use(
  (response) => response,
  (error) => {
    const status = error.response?.status;
    const requestUrl = String(error.config?.url ?? "");

    if (
      status === 401 &&
      !requestUrl.includes("/auth/founder/login") &&
      !requestUrl.includes("/auth/founder/login/mfa") &&
      !requestUrl.includes("/auth/founder/password-setup")
    ) {
      invalidateAuthSession();
    }

    return Promise.reject(error);
  },
);

export default founderApi;

export type ApiResponse<T> = {
  success: boolean;
  message: string;
  data: T;
};
